<template>
  <omk-tabs
    v-if="whitelabel.omDesign"
    active-tab-index="0"
    tab-emphasis="normal"
    :active-tab-index="activeTab"
  >
    <omk-tab
      v-for="(title, index) in tabTitles"
      :key="index"
      aria-controls="video-panel"
      tab-type="primary"
      :tab-text="title"
      @click="handleChange(index)"
    ></omk-tab>
  </omk-tabs>
  <div v-else class="tabbed-content-tabs">
    <Tabs
      :titles="tabTitles"
      @tabSelected="handleChange"
      :activeTab="activeTab"
    />
  </div>
</template>

<script>
  import Tabs from '../Tabs.vue';
  export default {
    name: 'TabComponent',
    inheritAttrs: false,
    components: {
      Tabs,
    },
    props: {
      value: {
        type: [String, Number, Boolean],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      prefix: {
        type: String,
        default: '',
      },
      suffix: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: true,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
      autocomplete: {
        type: String,
        default: 'off',
      },
      hint: {
        type: String,
        default: '',
      },
      persistentHint: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        required: false,
      },
      errors: {
        type: Array,
        default: () => [],
      },
      isDateField: {
        type: Boolean,
        default: false,
      },
      remainderOfEstateMargin: {
        type: Boolean,
        default: false,
      },
      max: {
        type: Number,
        default: null,
      },
      items: {
        type: Array,
        default: () => [],
      },
      color: {
        type: String,
        default: 'primary',
      },
      activeClass: {
        type: String,
        default: '',
      },
      className: {
        type: String,
        default: '',
      },
      flexColumn: {
        type: Boolean,
        default: false,
      },
      tabTitles: {
        type: Array,
        default: () => [],
      },
      activeTab: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      handleChange(index) {
        this.$emit('tabSelected', index);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
